﻿'use strict'

import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';

import View_Page from '../views/page/page';

//import View_InfoPage from '../views/infoPage2/infoPage';
import View_InfoPage_10 from '../views/infoPage10/infoPage';
import View_InfoPage_20 from '../views/infoPage20/infoPage';
import View_InfoPage_30 from '../views/infoPage30/infoPage';
import View_InfoPage_42 from '../views/infoPage42/infoPage';
import View_InfoPage_110 from '../views/infoPage110/infoPage';
import View_NoAuth from '../views/noAuth/noAuth';

import * as Entities_Memory from '../entities/memory';


import * as Entities_PublicConfigSetting from '../entities/publicConfigSetting';
import View_DialogBox from '../../lib/views/dialogBox/dialogBox';


import config from '../../common/config';

export default Marionette.AppRouter.extend({
    initialize: function () {
        this.app = this.options.app;

        var self = this;

        
    },
    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
        var params = route.exec(fragment).slice(1);
        return _.map(params, function(param, i) {
            // Don't decode the search params.
            if (i === params.length - 1) return param || null;
            
            //return param ? decodeURIComponent(param) : null;
            var myparams = '';
            try {
                myparams = decodeURIComponent(param);
            } 
            catch(err) {
                var escape_decodeURI = escape(param);
                myparams = decodeURIComponent(escape_decodeURI);
            }

            return myparams;
        });
    },
    routes: {
        "infoPage": "infoPage",
        "noAuth": "noAuth",
        "page/:navigationName": "page",
        '*notFound': 'notFound'
    },
    notFound: function (navigationName) {
        if (navigationName && navigationName.length > 0) {
            this.app.trigger('event4us', navigationName);
        }else {
            this.app.initContent();
        }
    },
    infoPage: function () {
        var self = this;
        
        document.title = resources.X200099 + resources.X200159;

        var collection = new Entities_Memory.Collection();
        
        //var infoPage = new View_InfoPage({ model: self.app.entities.models.customDepartment, collection: self.app.entities.collections.customDepartmentUser, app: self.app });

        var infoPage;

        switch (self.app.entities.models.customDepartment.attributes.PersonOnView) {
            case 10: infoPage = new View_InfoPage_10({ model: self.app.entities.models.customDepartment, collection: collection, app: self.app }); break;
            case 20: infoPage = new View_InfoPage_20({ model: self.app.entities.models.customDepartment, collection: collection, app: self.app }); break;
            case 30: infoPage = new View_InfoPage_30({ model: self.app.entities.models.customDepartment, collection: collection, app: self.app }); break;
            case 42: infoPage = new View_InfoPage_42({ model: self.app.entities.models.customDepartment, collection: collection, app: self.app }); break;
            case 110: infoPage = new View_InfoPage_110({ model: self.app.entities.models.customDepartment, collection: collection, app: self.app }); break;
        }
        
        this.app.regions.main.show(infoPage);
    },
    noAuth: function () {
        var self = this;

        document.title = resources.X200099 + resources.X200159;

        var noAuth = new View_NoAuth({ });
        this.app.regions.main.show(noAuth);
    },
    page: function (id, eventId) {
        var customEvent = app.entities.collections.customEvent.where({ id: eventId })[0];
        var model = app.entities.collections.customModule.where({ id: id })[0];
        var data = JSON.parse(model.attributes.Data)[0];
        var collection = new Backbone.Collection(data.Collection);

        var page = new View_Page({ collection: collection, model: model, app: this.app, eventId: eventId, customEvent: customEvent });
        this.app.regions.main.show(page);
    }
});



